import script from "./MainTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./MainTabs.vue?vue&type=script&setup=true&lang=js"

import "./MainTabs.vue?vue&type=style&index=0&id=4ccdf0e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ccdf0e8"]])

export default __exports__